module.exports = __webpack_public_path__ + "static/media/goodnest_app8.58912565.jpg";